<template>
  <div class="mkt-form-step">
    <!-- <md-card-header>
        <md-avatar class="md-avatar-icon step-content-num">2</md-avatar>
        <div class="md-title">Select Products</div>

        
    </md-card-header>-->
    <md-card-header>
      <md-avatar class="md-avatar-icon step-content-num">2</md-avatar>
      <div class="md-title">Select Products</div>
    </md-card-header>

    <md-card-content style="height:calc(100vh - 200px);padding-top: 1vh;padding-left: 6vh;">
      <div class="md-layout">
        <div class="md-layout-item md-size-5" style="min-width:150px !important;">
          <!-- <md-button
            class="md-raised md-primary btn-browser"
            style="width:134px;height:60px;"
            @click="openDialogImportProduct"
          >
            <md-icon>search</md-icon>browse
          </md-button>-->
          <md-button
            class="md-raised md-button-template btn-template"
            @click="openDialogTemplate()"
            style="background-color: #A8A8A8 !important;color:white !important;width:134px;height:60px;"
          >
            <md-icon style="color:white;">file_upload</md-icon>Upload
          </md-button>
        </div>
        <div class="md-layout-item">
          <div
            clsss="block-tree"
            style="border-radius: 5px;padding:12px;background-color: #F7F7F7;height:60px;margin-top:5px;"
          >
            <treeselect
              class="treeview-box"
              :multiple="true"
              :limit="1"
              :maxHeight="300"
              placeholder="+ Add with Product Code"
              :async="true"
              :load-options="loadOptions"
              :cache-options="false"
              v-model="valueTree"
              :clearable="false"
              :value-consists-of="valueConsistsOf"
              @select="openOnSelectTreeview"
              @deselect="onDeSelectTreeview"
              @open="onOpenTreeview"
              style="z-index:30"
              searchPromptText="Code or Name or Group or Subgroup or CG"
            >
              <!-- :value-consists-of="valueConsistsOf" -->
              <div
                slot="option-label"
                slot-scope="{ node }"
              >{{node.raw.code}} : {{node.raw.title_th}}</div>
            </treeselect>
          </div>

          <!-- <div class="search-products">
            <md-field class="input-search">
              <label class="input-search-label">Product Code (if multiple, seperate by space)</label>
              <md-input v-model="product_code" @keyup.enter.native="addProducts"></md-input>
            </md-field>
            <md-button @click="addProducts()" class="btn-add-product md-primary">add</md-button>
            <md-button @click="clearProducts()" class="btn-clear-product">clear</md-button>
          </div>-->
        </div>
      </div>

      <div class="md-layout">
        <md-empty-state
          v-show="this.value.products.length == 0"
          md-label
          md-description="No products selected for import"
        ></md-empty-state>

        <md-toolbar md-elevation="0" class="table-toolbar" v-show="this.value.products.length > 0" style="background-color:white;">
          <div class="md-toolbar-section-start">
            <span class="title" style="font-size:18px;">Select Products</span>
          </div>
          <div class="md-toolbar-section-end">
            <md-field md-clearable>
              <md-icon>search</md-icon>
              <md-input
                v-model="search"
                placeholder="Search product code or description"
                @input="searchOnTable"
              />
            </md-field>
            <md-button refs="btndelete" class="md-icon-button md-primary" @click="removeProduct()">
              <md-icon
                v-bind:style="chkImport.length === 0 ? {color: '#A8A8A8'} : {color: '#3F51B5'}"
                class="md-theme-primary"
              >delete_sweep</md-icon>
            </md-button>
          </div>
        </md-toolbar>
        <div style="height:calc(100vh - 340px);width:98%;overflow:auto;">
          <table v-if="value.products.length > 0">
            <thead>
              <th width="2%" class="sticky-header">
                <md-checkbox v-model="chkAll" @change="selectedAll" class="md-primary" style="padding:0px;"></md-checkbox>
              </th>
              <th width="7%" class="sticky-header">Code</th>
              <th width="20%" class="sticky-header">Description</th>
              <th width="5%" class="sticky-header">Unit</th>
              <th width="5%" class="sticky-header">Cost</th>
            </thead>
            <tbody>
              <tr v-for="(item,index) in searched" :key="index">
                <td>
                  <md-checkbox style="padding-left:5px;" v-model="chkImport" :value="item.code" class="md-primary"></md-checkbox>
                </td>
                <td>{{ item.code }}</td>
                <td>{{ item.title_th }}</td>
                <td>{{ item.selling_um_title}}</td>
                <td>{{ item.cost.toString().toLocaleString() }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- <md-table
        class="Select-Table"
        style="height:calc(100vh - 280px);width:100%"
        ref="searchedTable"
        v-model="searched"
        md-sort="title_th"
        md-sort-order="asc"
        @md-selected="onSelect"
        md-fixed-header
        :md-is-selected="true"
        v-if="value.products.length > 0"
      >
        <md-table-toolbar class="table-toolbar">
          <div class="md-toolbar-section-start" style="margin-left: 8vh;">
            <span class="title" style="font-size:18px;">Select Products</span>
          </div>
          <div class="md-toolbar-section-end">
            <md-field md-clearable>
              <md-icon>search</md-icon>
              <md-input
                v-model="search"
                placeholder="Search product code or description"
                @input="searchOnTable"
              />
            </md-field>
            <md-button refs="btndelete" class="md-icon-button md-primary" @click="removeProduct()">
              <md-icon
                v-bind:style="selected.length === 0 ? {color: '#A8A8A8'} : {color: '#3F51B5'}"
                class="md-theme-primary"
              >delete_sweep</md-icon>
            </md-button>
          </div>
        </md-table-toolbar>
        <md-table-row slot="md-table-row" slot-scope="{ item }" md-selectable="multiple">
          <md-table-cell md-label="Code" class="sub-column">{{ item.code }}</md-table-cell>
          <md-table-cell
            class="md-table-cell-description"
            md-label=" Description"
            :title="item.title_th"
          >{{ item.title_th }}</md-table-cell>
          <md-table-cell md-label=" "></md-table-cell>
          <md-table-cell md-label="Unit" class="sub-column">{{ item.selling_um_title}}</md-table-cell>
          <md-table-cell
            md-label="Cost"
            md-numeric
            class="sub-column"
          >{{ item.cost.toString().toLocaleString() }}</md-table-cell>
        </md-table-row>
        </md-table>-->
      </div>
    </md-card-content>

    <md-dialog-alert
      :md-active.sync="alertEmpty"
      md-content="Please input product code!"
      md-confirm-text="OK"
    />

    <dialogImportProduct
      ref="dialogImport"
      @importProduct="onImportProduct"
      :productsImport="productsImport"
    ></dialogImportProduct>

    <dialogTemplate
      :productsImport="productsImport"
      :showDialog="showDialogTemplate"
      @onCancel="showDialogTemplate = $event"
      @onImportExcelFile="onImportExcelFile"
    ></dialogTemplate>

    <dialogImportProductExcel
      :showDialog="showDialogExcel"
      @onCancel="showDialogExcel = $event"
      :products="dataProductsFromExcel"
      :importedProduct="value.products"
      @onImport="onImportFromExcel"
    ></dialogImportProductExcel>
  </div>
</template>

<script>
import ProductService from "@/services/product";
import PricingService from "@/services/pricing";

import dialogImportProduct from "@/components/campaign/share/dialogImportProduct";
import dialogImportProductExcel from "@/components/campaign/share/dialogImportProductExcel";
import dialogTemplate from "@/components/campaign/share/dialogTemplate";

import Treeselect from "@riophae/vue-treeselect";
import { ASYNC_SEARCH } from "@riophae/vue-treeselect";

import XLSX from "xlsx";

import _ from "lodash";
const simulateAsyncOperation = fn => {
  setTimeout(fn, 2000);
};
const toLower = text => {
  return text.toString().toLowerCase();
};

const searchByName = (items, term) => {
  if (term) {
    if (items.length > 0)
      return items.filter(
        item =>
          toLower(item.code).includes(toLower(term)) ||
          toLower(item.title_th).includes(toLower(term))
      );
  }

  return items;
};

export default {
  name: "campaign-step2",
  props: ["value"],
  components: {
    dialogImportProduct,
    dialogImportProductExcel,
    dialogTemplate,
    Treeselect
  },
  data() {
    return {
      products: [],
      product_code: "",
      tickets: [{ name: "test" }],
      headers: ["Test header"],
      datacsv: "test",
      accept: ".xlsx, .xls, .csv",
      dataExcelImport: [],
      search: null,
      searched: [],
      alertEmpty: false,
      selected: [],
      productsImport: [],

      showDlgExcel: false,
      dataProductsFromExcel: [],

      showDialogTemplate: false,
      showDialogExcel: false,

      valueConsistsOf: "LEAF_PRIORITY",
      valueTree: [],
      createDatas: [],
      dataTreeview: [],
      checkedProducts: [],
      createDatasOld: [],
      // checkedLengthProducts: [],
      chkAll: false,
      chkImport: []
    };
  },
  created() {
    this.searched = this.value.products;
    this.value.products.forEach(el => {
      this.valueTree.push(el.id);
      this.checkedProducts.push(el.id);
      // this.checkedLengthProducts.push(el.id);
    });
  },
  computed: {
    unitmaster() {
      return this.$store.getters["cpcreate/unitmaster"];
    }
  },
  methods: {
    calc(num) {
      if (num == "" || num == null) return "0.00";
      else {
        num = num.toString();
        num = num.slice(0, num.indexOf(".") + 3);

        return num;
      }
    },
    openDialogImportProduct() {
      this.productsImport = _.clone(this.value.products);
      this.$refs.dialogImport.showDialog = true;
    },
    onImportProduct(products) {
      let prod = [];
      let _self = this;

      products.forEach(function(el) {
        prod.push(el.code);
      });

      ProductService.getPrice(prod).then(response => {
        let products = [];
        response.forEach(function(el) {
          if (el.price == "" || el.price == null) el.price = "0.00";
          else el.price = _self.calc(el.price);
          if (el.cost == "" || el.cost == null) el.cost = "0.00";
          else el.cost = _self.calc(el.cost);
          products.push(el);
        });

        this.value.products = products;
        this.searched = this.value.products;
      });

      // console.log(prod);
      // return;
    },
    trigger() {},
    messageClass() {},

    searchOnTable() {
      this.searched = searchByName(this.value.products, this.search);
    },
    onSelect(items) {
      this.selected = items;
    },
    addProducts() {
      if (this.product_code == "") {
        this.alertEmpty = true;
        return;
      }

      let productGroup = this.product_code.replace(" ", "").split(",");

      ProductService.checkProductsImport(productGroup)
        .then(res => {
          this.dataProductsFromExcel = res;
          this.showDialogExcel = true;
          this.product_code = "";
        })
        .catch(err => {});
    },
    clearProducts() {
      this.product_code = "";
    },
    trigger_upload() {
      this.$refs.fileInput.click();
    },
    removeProduct() {

      let _self = this;
      this.value.products = this.value.products.filter(item => !this.chkImport.includes(item.code))
      console.log(this.chkImport);
      console.log(this.value.products);

      this.searched = this.value.products;

     
      this.valueTree = [];
      this.checkedProducts = [];

      this.value.products.forEach(el=>{
        this.valueTree.push(el.id);
        this.checkedProducts.push(el.id);
      })

      this.chkImport = [];

      if(this.selected.length == 0) this.chkAll = false;

      // this.value.products = this.searched;



      // this.value.products = [];
      //return;

      // for (let i = 0; i < this.chkImport.length; i++) {
      //   for (let j = 0; j < this.searched.length; j++) {
      //     if (this.searched[j].code == this.selected[i].code)
      //       delete this.searched.splice(j, 1);
      //   }
      // }
      // this.selected = [];
      //this.value.products = [];
      //this.searched = this.value.products;
    },
    getProducts(data) {
      let productGroup = [];

      for (let i = 3; i < data.length; i++) {
        //console.log('prod',data[i])
        productGroup.push(data[i][0]);
      }

      this.searchProductByCode(productGroup);
    },
    searchProductByCode(productGroup) {
      let _self = this;
      ProductService.getPrice(productGroup).then(response => {
        if (response.length > 0) {
          response.forEach(function(el) {
            if (el.price == "" || el.price == null) el.price = "0.00";
            else el.price = _self.calc(el.price);
            if (el.cost == "" || el.cost == null) el.cost = "0.00";
            else el.cost = _self.calc(el.cost);

            if (!_self.isDupProduct(el.code)) {
              _self.value.products.push(el);
            } else {
              _self.$snack.show({
                text: "Item is duplicate.",
                button: "OK"
              });
            }
          });
        } else {
          this.$snack.show({
            text: "Item not found.",
            button: "OK"
          });
        }
      });
    },
    onImportExcelFile(data) {
      let products = [];

      for(let i = 1; i < data.length; i++)
      {
        products.push(data[i][0]);
      }

      ProductService.checkProductsImport(products)
        .then(res => {
          this.dataProductsFromExcel = res;
          this.showDialogTemplate = false;
          this.showDialogExcel = true;
        })
        .catch(err => {});
    },

    isDupProduct(code) {
      for (let i = 0; i < this.value.products.length; i++) {
        if (this.value.products[i].code == code) return true;
      }
      return false;
    },

    showImportFromExcel(data) {
      // this.$refs.fileInput.value = "";

      let products = [];

      data.splice(1).forEach(el => {
        products.push(el[0]);
      });

      ProductService.checkProductsImport(products)
        .then(res => {
          this.dataProductsFromExcel = res;
          this.showDlgExcel = true;
        })
        .catch(err => {});
    },

    onImportFromExcel(products) {

      this.searchProductByCode(products);
      this.showDialogExcel = false;
    },
    openDialogTemplate() {
      this.showDialogTemplate = true;
    },
    loadOptions({ action, searchQuery, callback }) {
      let text = "";
      let type = "input";

      if (searchQuery.split(" ").length <= 1) {
        text = searchQuery;
      } else {
        let splitText = searchQuery.split(" ");
        if (splitText.length < 1000) {
          let texts = "";
          splitText.forEach(function(value, key) {
            texts += value + ",";
          });
          text = texts.substring(0, texts.length - 1);
          type = "paste";
        } else {
          this.dContent = "Data input text have Code more than 1000 Code.";
          this.showSnackbar = true;
          return false;
        }
      }

      if (action === ASYNC_SEARCH && searchQuery.length > 1) {
        ProductService.advancedSearch(text)
          .then(response => {
            // self.valueTree = response;
            callback(null, response);
            // self.optionsTreeview = response;
          })
          .catch();
      }

      //       let self = this;
      //       let text = "";
      //       let type = "input";
      //       if (searchQuery.split(" ").length <= 1) {
      //         text = searchQuery;
      //       } else {
      //         let splitText = searchQuery.split(" ");
      //         if (splitText.length < 1000) {
      //           let texts = "";
      //           splitText.forEach(function(value, key) {
      //             texts += value + ",";
      //           });
      //           text = texts.substring(0, texts.length - 1);
      //           type = "paste";
      //         } else {
      //           this.dContent = "Data input text have Code more than 1000 Code.";
      //           this.showSnackbar = true;
      //           return false;
      //         }
      //       }

      //       console.log(text)

      //       if (action === ASYNC_SEARCH && text.length > 0) {

      // ;
      //         // simulateAsyncOperation(() => {
      //         // ProductService.ProductTree(text, type, this.checkDataDelete)
      //         //   .then(response => {
      //         //     self.optionsTreeview = response;
      //         //     self.dataLoaded = response;

      //         //     if (type == "paste") {
      //         //       this.dataLoaded.forEach(function(value, key) {
      //         //         let index = self.valueTree
      //         //           .map(function(e) {
      //         //             return e;
      //         //           })
      //         //           .indexOf(value.id);

      //         //         if (index == -1) {
      //         //           self.valueTree.push(value.id);
      //         //           self.setDataArrayTree("last", value);
      //         //         }
      //         //       });
      //         //     }

      //         //     callback(null, self.optionsTreeview);
      //         //   })
      //         //   .catch();
      //         // })
      //       }
    },
    openOnSelectTreeview(node) {
      let self = this;
      if (node.children) {
        node.children.forEach(function(value, key) {
          if (value.children) {
            self.openOnSelectTreeview(value);
            // console.log(value);
          } else {
            //Check ตัวแม่จาก level รองสุดท้าย
            self.setDataArrayTree("", value);
          }
        });
      } else {
        //Check last level
        self.setDataArrayTree("last", node);
      }
    },
    onDeSelectTreeview(node) {
      // console.log("node DeSelect==>", node);
      let self = this;
      if (node.children) {
        node.children.forEach(function(value, key) {
          if (value.children) {
            self.onDeSelectTreeview(value);
          } else {
            //Check ตัวแม่จาก level รองสุดท้าย
            let index = self.value.products
              .map(function(e) {
                return e.id;
              })
              .indexOf(value.id);
            if (index > -1) {
              self.value.products.splice(index, 1);
              self.checkedProducts.splice(index, 1);
              // self.checkedLengthProducts.splice(index, 1);
            }
          }
        });
      } else {
        //Check last level
        let index = self.value.products
          .map(function(e) {
            return e.id;
          })
          .indexOf(node.id);

        console.log(index);
        self.value.products.splice(index, 1);
        self.checkedProducts.splice(index, 1);
        // self.checkedLengthProducts.splice(index, 1);
      }

      this.createDatasOld = [];
      this.createDatasOld = this.value.products;
      // console.log("this.dataTreeview DE-SELECT ==>", this.dataTreeview);
    },
    onOpenTreeview() {
      this.vFilter = "";
      this.filterTable();
    },
    setDataArrayTree(check, value) {
      let index = this.value.products
        .map(function(e) {
          return e.id;
        })
        .indexOf(value.id);

      if (index == -1) {
        //ไม่เจอ
        let datas = {
          id: value.id,
          title_th: value.title_th,
          code: value.code,
          // price: (value.price == "" || value.price == null)? "0.00" : this.calc(value.price),
          cost:
            value.cost == "" || value.cost == null
              ? "0.00"
              : this.calc(value.cost),
          selling_um_title: value.selling_um_title
        };
        if (check == "last") {
          let key = this.dataTreeview.length;
          this.dataTreeview[key] = datas;
        } else {
          this.dataTreeview.push(datas);
        }

        this.checkedProducts.push(value.code);
      }

      // this.checkedProducts.push(value.code);
      let arrs = this.value.products.concat(this.dataTreeview);

      // this.value.products = arrs;
      // this.search = arrs;

      this.value.products = arrs;
      this.searched = this.value.products;

      this.dataTreeview = [];
      this.createDatasOld = [];
      this.createDatasOld = this.value.products;

      // this.checkedProducts.push(this.createDatas[itemCode].item_code);
      // this.createDatas = this.dataTreeview;
    },
    onOpenTreeview() {},
    selectedAll(event) {
      if (event) {
        this.chkImport = [];
        this.value.products.forEach(el => {
          this.chkImport.push(el.code);
          // this.checkedProducts.push(el.code);
        });
      } else {
        this.chkImport = [];
        // this.checkedProducts = [];
      }
    },
    isValidate(){
      if(!this.value.campaign_code){
        // alert('Please input code.');
        // this.showAlert = true;
        // this.alertContent = "Please input code.";
        // this.$refs.frm_campaign_code.$el.focus();
        // return false;
      }
    }
  }
};
</script>
<style lang="scss">
.md-content.md-table.Select-Table.md-theme-default {
  .md-toolbar.md-table-toolbar.md-transparent.table-toolbar.md-theme-default.md-elevation-0 {
    border-bottom-color: rgba(0, 0, 0, 0);
  }
  .md-table-fixed-header.md-table-fixed-header-active {
    border: 0;
  }
  .md-content.md-table-content.md-scrollbar.md-theme-default {
    table {
      tbody {
        .md-table-row {
          .md-table-cell {
            border-top-color: rgba(0, 0, 0, 0);
          }
        }
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.md-card-header {
  height: 70px;
  .md-title {
    padding-top: 10px;
    font-size: 18px;
  }
}

.mkt-form-step {
  .btn-box {
    width: 30%;
    .btn-browser {
      width: 40%;
      height: 80%;
      display: inline-block;
    }
    .btn-template {
      width: 150px;
      height: 80%;
      display: inline-block;
    }
  }
  .input-box {
    width: 70%;
  }
}

.mktops-browse-file {
  display: none;
}

.search-products {
  margin-top: 5px;
  background: #f7f7f7;
  border-radius: 10px;
  height: 60px;
  display: flex;
  flex-direction: row;

  .input-search {
    // display: inline-block;
    width: 60%;
    overflow: hidden;
    margin-left: 10px;

    .input-search-label {
      font-size: 13px;
    }
  }

  .btn-add-product {
    // display: inline-block;
    font-size: 16px;
    margin-top: 12px;

    align-items: flex-start;
    // width: 15%;
    // float: right;
  }
  .btn-clear-product {
    // display: inline-block;
    font-size: 16px;
    margin-top: 12px;

    text-align: center;
    // width: 15%;
    // float: right;
  }
}

.md-empty-state {
  color: gray;
}

table {
  border-collapse: collapse;
  width: 100%;
}

th,
td {
  padding: 5px;
  text-align: left;
}

tr:hover {
  background-color: #f5f5f5;
}

th.sticky-header {
  position: sticky;
  top: -10px;
  z-index: 20;
  // #To not have transparent background.
  background-color: white;
  padding: 10px;
}
</style>